import { createContext } from 'react';

export const NotificationContext = createContext<{
  notification: any;
  setShowNotification: any;
}>({ notification: null, setShowNotification: () => {} });
